module.exports = __webpack_public_path__ + "img/1.56bb40b4.jpg";